import { Col, Row } from "antd";
import { EmptyContent } from "./EmptyContent";
import { OfficeList } from "../desktop/components/OfficeList";
import { ScreenLayout } from "./ScreenLayout";
import { SkeletonCard } from "./Loaders/SkeletonCard";
import React, { useGlobal } from "reactn";

export const FavoritesScreen = () => {
	const [favorites = []] = useGlobal("favorites");
	const [offices = []] = useGlobal("offices");
	const [officesv2] = useGlobal("officesv2");

	const { isLoading: loading } = officesv2;

	const { offices: favoriteOffices = [] } = favorites;

	const filteredOffices =
		(!!favoriteOffices.length &&
			Object.values(offices).filter((office) =>
				favorites.offices.includes(office.id)
			)) ||
		[];

	return (
		<ScreenLayout
			title="Mis Favoritos"
			description="Accesos directos a tus sucursales preferidas:"
		>
			{!loading && !filteredOffices.length && (
				<EmptyContent description="No tienes sucursales favoritas todavía..."></EmptyContent>
			)}
			{loading && (
				<Row gutter={12} justify="center" align="middle">
					{favoriteOffices.map((_, i) => (
						<Col key={i}>
							<SkeletonCard size={600}></SkeletonCard>
						</Col>
					))}
				</Row>
			)}
			{!!filteredOffices.length && (
				<OfficeList center offices={filteredOffices}></OfficeList>
			)}
		</ScreenLayout>
	);
};
